/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import router from "./router";
// import store from './store'
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, setOpenid, getOpenid } from "@/utils/cookies"; // getToken from cookie
import { wxAuthorization } from "@/utils/common";
// import { wechatLogin, isWxLogin } from '@/api/login'
import wxApi from "@/utils/utils";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/MP_verify_wZSiO4oYiKdZgaRs.txt"]; // no redirect whitelist
// const whiteList = []
router.beforeEach(function (to, from, next) {
  NProgress.start(); // start progress barstore.getters.token
  var params = new URLSearchParams(window.location.search);
  if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else if (getOpenid()) {
    // 是否有登录微信授权的
    if (getToken()) {
      // 是否已登录啪啪授权的
      next();
    } else if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  } else if (params.get("code")) {
    console.log(params.get("code"), "授权码");
    next();
    setOpenid(params.get("code"));
    NProgress.done();
  } else {
    wxAuthorization();
    next();
    NProgress.done();
  }
});
router.afterEach(function () {
  NProgress.done(); // finish progress bar
});